import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const UrlAccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Verificar parámetros de URL para acceso directo
    const accessKey = searchParams.get('access');
    const adminKey = searchParams.get('admin');
    const divertilandiaKey = searchParams.get('divertilandia');

    // Diferentes formas de acceder:
    // ?access=divertilandia
    // ?admin=true
    // ?divertilandia=admin
    
    if (accessKey === 'divertilandia' || adminKey === 'true' || divertilandiaKey === 'admin') {
      navigate('/divertilandia/signin');
    }
  }, [searchParams, navigate]);

  return null; // Este componente no renderiza nada
};

export default UrlAccess;
